import type { TrackerResult } from '../tracking/protocol';
export interface TraceFrame {
  captureMs: number; resultMs: number; inferMs: number; width: number; height: number; faceCount: number;
  landmarks: number[] | null; matrix: number[] | null;
}
export interface TrackingTrace {
  schema: 'mata-tracking-trace-1'; videoWidth: number; videoHeight: number; longSideFovDeg: number;
  frameId: string; frames: TraceFrame[];
}
/** Explicit local diagnostic recording; no images, network, persistence or automatic start. */
export class TraceRecorder {
  private trace: TrackingTrace | null = null;
  private origin = 0;
  private active = false;
  get recording(): boolean { return this.active; }
  start(meta: Omit<TrackingTrace, 'schema' | 'frames'>, nowMs: number): void {
    this.trace = { schema: 'mata-tracking-trace-1', ...meta, frames: [] }; this.origin = nowMs; this.active = true;
  }
  push(r: TrackerResult, resultMs: number): void {
    if (!this.active || !this.trace) return;
    if (resultMs - this.origin > 30_000 || this.trace.frames.length >= 1800) { this.active = false; return; }
    this.trace.frames.push({ captureMs: r.captureTs - this.origin, resultMs: resultMs - this.origin, inferMs: r.inferMs,
      width: r.width, height: r.height, faceCount: r.faceCount, landmarks: r.landmarks ? Array.from(r.landmarks) : null, matrix: r.matrix ? Array.from(r.matrix) : null });
  }
  stop(): TrackingTrace | null { this.active = false; return this.trace; }
  clear(): void { this.active = false; this.trace = null; }
}
